import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormikWrapper,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CheckboxAndRadio as Checkbox,
} from '../../../../components';


import './style.scss';

const GarbageForm = ({ onSubmit, value, setSearchValue, selectOptions, onSelectedRecognitions, className }) => {
  const { t } = useTranslation();
  const [selectedValues, setSelectedValues] = React.useState([]);

  return (
    <form onSubmit={handleSubmit} className={`GarbageCompaniesSearchForm ${className}`}>
      <div className="GarbageCompaniesSearchForm__wrapper row">
        <div className="query-holder col-12 TextField">
          <div className="GarbageCompaniesSearchForm__wrapper__item">
            {t('filters.companies.query.label')}
          </div>
          <div className="GarbageCompaniesSearchForm__wrapper__icon">
            <input
              name="query"
              aria-label={t('filters.garbage_companies.query.placeholder')}
              defaultValue={value}
              placeholder={t('filters.garbage_companies.query.placeholder')}
              onKeyUp={handleOnKeyUp}
            />
            <i className="icon-after icon-search" />
          </div>
        </div>
        <div className="col-12">
          <FormikWrapper>
            <span className="GarbageCompaniesSearchForm__wrapper__item">
              {t('filters.garbage_companies.recognizes.label')}
            </span>
            <div className="Items">
              {selectOptions.map((item) => (
                <div
                  key={`term-${item.name}`}
                  className="CheckboxWrapper"
                >
                  <Checkbox
                    className="Checkbox"
                    label={item.name}
                    value={item.name}
                    id={`recognition-${item.name}`}
                    checked={selectedValues.includes(item.name)}
                    onChange={handleCheckboxChange}
                  />
                </div>
              ))}
            </div>
          </FormikWrapper>
        </div>
      </div>
    </form>
  );

  function handleCheckboxChange(e) {
    const isSelected = selectedValues.includes(e.target.value);
    const newValues = isSelected
      ? selectedValues.filter((v) => v !== e.target.value)
      : [...selectedValues, e.target.value];

    const truthyValues = newValues.filter((x) => x !== undefined);
    setSelectedValues(truthyValues);
    onSelectedRecognitions(truthyValues);
  }

  function handleOnKeyUp(e) {
    setSearchValue(e.target.value);
    onSubmit();
  }

  function handleSubmit(e) {
    onSubmit();
    e.preventDefault();
  }
};

GarbageForm.defaultProps = {
  className: '',
};

export default GarbageForm;
